import React, { useState, useEffect } from "react";
import slugify from "react-slugify";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { PageMessages } from "./messages";
import { PageComments } from "./comments";
import { WEB_URL } from "../../../api/URLs";
import { TeamSection } from "./TeamSection";
import useStyles from "./styles/MobileViewStyles";
import UserInfoBox from "../../events/page/UserInfoBox";
import DefaultCover from "../../../assets/images/cover.jpg"
import { getPercentage, history } from "../../../helpers";
import { fundRaiserPageAction } from "../../../store/actions";
import { InviteTeamMemberModal, ShareFundraiserModal, WarningModal } from "../../../components/modals";
import { ProgressBar, ContentWithHeading, LongText, MixPanelTrackedLink, DonationList } from "../../../components";
import { CLOSED_PAGE, DONATIONS_LIST_TYPE, DRAFT_PAGE, GTM_EVENTS, S3_BUCKET, SINGLE_OWNER_PAGE, TEAM_PAGE } from "../../../constants";
import { useNavigate } from "react-router-dom";

export function MobileView() {
    const classes = useStyles();
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
    const donationsLimit = 10;
    const donationsOffset = 0;
    const { HIGHEST_DONATIONS, RECENT_DONATIONS } = DONATIONS_LIST_TYPE;

    const user = useSelector(state => state.authentication.user);
    const pageMessages = useSelector(state => state.fundraiser_page.pageMessages);
    const pageComments = useSelector(state => state.fundraiser_page.fundraiser_page_updates)
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);
    const highestDonations = useSelector(state => state.get_all_fundraiser_page_most_donations.highestDonations.donations);
    const highestDonationsCount = useSelector(state => state.get_all_fundraiser_page_most_donations.highestDonations.totalDonations)
    const recentDonations = useSelector(state => state.get_all_fundraiser_page_mostrecent_donations.recentDonations.donations);
    const recentDonationsCount = useSelector(state => state.get_all_fundraiser_page_mostrecent_donations.recentDonations.totalDonations);

    const [warningMessage, setWarningMessage] = useState("");
    const [openShareModal, setOpenShareModal] = useState(false);
    const [openWarningModal, setOpenWarningModal] = useState(false);
    const [selectedTab, setSelectedTab] = useState(RECENT_DONATIONS);
    const [openInvitationModal, setOpenInvitationModal] = useState(false);

    const totalDonations = pageDetails.count_donations;
    const donationText = totalDonations > 1 ? 'donations' : 'donation';
    const currencySymbol = pageDetails.symbol_left == "$" ? pageDetails.symbol_left : pageDetails.symbol_left + " ";
    const fundRaised = pageDetails.total_fund_goal_millions;
    const amountWithCurrencySymbol = currencySymbol + fundRaised;
    const fundRaisedPercentage = getPercentage(pageDetails.total_fund_raised, pageDetails.fundraising_goal);

    const isOwner = () => {
        return pageDetails.user_id == user.id
    };

    const displayInviteButton = () => {
        return isOwner() && pageDetails.status !== CLOSED_PAGE &&
            pageDetails.page_type == TEAM_PAGE
    };
    const changeTab = () => {
        switch (selectedTab) {
            case HIGHEST_DONATIONS:
                setSelectedTab(RECENT_DONATIONS)
                break;

            case RECENT_DONATIONS:
                setSelectedTab(HIGHEST_DONATIONS)
                break;

            default:
                break;
        }
    };

    const loadHighestDonations = () => {
        dispatch(fundRaiserPageAction.getFundraiserMostDonated(pageDetails.id, donationsLimit, donationsOffset));
    };

    const loadRecentDonations = () => {
        dispatch(fundRaiserPageAction.getFundraiserRecentDonations(pageDetails.id, donationsLimit, donationsOffset));
    };

    const handleShareClick = () => {
        pageDetails.status == DRAFT_PAGE ?
            setWarningMessage("Please publish the page before sharing") :
            setOpenShareModal(true);
    };

    const handleDonateNowClick = () => {
        pageDetails.status == DRAFT_PAGE ?
            setWarningMessage("Please publish the page to accept donations") :
            navigate(WEB_URL.FUNDRAISER_CHECKOUT(pageDetails.event_id) + "?cntry=" + pageDetails.country_id + "&crncy=" + pageDetails.currency_id)
    };

    const handleInviteMemberClick = () => {
        pageDetails.status == DRAFT_PAGE ?
            setWarningMessage("Please publish the page before inviting new team members") :
            setOpenInvitationModal(true);
    };
    useEffect(() => {
        warningMessage && setOpenWarningModal(true);
    }, [warningMessage])

    useEffect(() => {
        !openWarningModal && setWarningMessage(null)
    }, [openWarningModal])

    useEffect(() => {
        if (pageDetails) { loadHighestDonations(); loadRecentDonations(); }
    }, [pageDetails])

    return <React.Fragment>
        <div className="headng-img-box">
            {isOwner() &&
                <MixPanelTrackedLink
                    type="button"
                    variant="outlined"
                    href={WEB_URL.UPDATE_FUNDRAISER(pageDetails.event_id, slugify(pageDetails.page_title))}
                    label="Edit Page"
                    context="Editing fundraiser page"
                    underline="none"
                >
                    Edit Page
                </MixPanelTrackedLink>
            }
        </div>
        <div className={classes.lazyLoadDiv} alt="">
            <LazyLoadImage
                src={S3_BUCKET + pageDetails.cover_image} // use normal <img> attributes as props
                effect="blur"
                style={{ borderRadius: '15px', width: '100%', border: '1px solid #eee' }}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = DefaultCover
                }}
            />
        </div>
        <div className={classes.consistentPadding}>
            <Typography className={classes.goalRaised}>
                {pageDetails.symbol_left} {pageDetails.total_fund_raised.toLocaleString()}
            </Typography>

            <Typography className={classes.donationInfo}>
                raised of {amountWithCurrencySymbol} from <b>{totalDonations}</b> {donationText}
            </Typography>

            <ProgressBar percentage={fundRaisedPercentage} />
        </div>
        <div className="campaign-progress-record">
            <div className={`${classes.consistentPadding} cam-pro-rec-top`}>
                {
                    pageDetails.show_impact_message == 1 &&
                    <div className={classes.productImapact}>
                        {!pageDetails.is_special ? (pageDetails.product_impact ?
                            <Typography>Supporting the education of <b>{pageDetails.product_impact.product_impact}</b> {pageDetails.product_impact.product_impact && pageDetails.product_impact.product_impact > 1 ? ' children' : ' child'}</Typography> :
                            'Donate and help bring education to deserving children'
                        ) :
                            'Your donation supports the flood relief affectees in Pakistan'
                        }
                    </div>
                }
                {pageDetails.status == CLOSED_PAGE && <div className="page-closed">
                    <Typography>
                        This fundraiser is now closed. Please <MixPanelTrackedLink type="link" label="click here" href={WEB_URL.FUNDRAISER_LISTING} underline="none">click here</MixPanelTrackedLink> to view other fundraisers you can support.
                    </Typography>
                </div>}
            </div>
            <Grid justifyContent="center" container gap={1} className={`${classes.donationButtonsDiv}`}>
                <Grid item xs={12}>
                    <Stack direction={'row'} spacing={1}>
                        <MixPanelTrackedLink
                            type="button"
                            variant="contained"
                            label="Share"
                            color="secondary"
                            context={`${pageDetails.page_title} details page`}
                            className={classes.shareButton}
                            onClick={handleShareClick}
                            sx={{ fontSize: '1rem', fontWeight: 'bold' }}
                            fullWidth
                        >Share</MixPanelTrackedLink>
                        {(
                            pageDetails.status !== CLOSED_PAGE
                                ?
                                <MixPanelTrackedLink
                                    type="button"
                                    label="Donate Now"
                                    variant="contained"
                                    underline="none"
                                    color="primary"
                                    context={`${pageDetails.page_title} details page`}
                                    sx={{ fontSize: '1rem', whiteSpace: 'nowrap', fontWeight: 'bold' }}
                                    onClick={handleDonateNowClick}
                                    gtmProps={{
                                        fundrasier_name: pageDetails.page_title,
                                        raised_amount: pageDetails.total_fund_raised,
                                        number_of_donation: pageDetails.count_donations,
                                        goal_amount: pageDetails.fundraising_goal
                                    }}
                                    gtmEvent={GTM_EVENTS.DONATE_NOW_CLICKED}
                                    fullWidth
                                >Donate now</MixPanelTrackedLink>
                                :
                                null
                        )}
                    </Stack>
                </Grid>
                {
                    displayInviteButton() && <Grid item xs={12}>
                        <MixPanelTrackedLink
                            type="button"
                            variant="contained"
                            label="Invite a team member"
                            color="primary"
                            context="Invite a team member"
                            className={classes.donationButtons}
                            onClick={handleInviteMemberClick}
                            sx={{ fontSize: '1rem', fontWeight: 'bold', }}
                            fullWidth
                        >Invite a team member</MixPanelTrackedLink>
                    </Grid>}
            </Grid>

            <Divider className={classes.sectionSeparator} />
            <ContentWithHeading heading={pageDetails.page_title} _className={classes.consistentPadding}>
                {pageDetails.page_type == SINGLE_OWNER_PAGE &&
                    <UserInfoBox imageUrl={S3_BUCKET + pageDetails.profile_image} ownerName={pageDetails.first_name + " " + pageDetails.last_name} sx={{ mb: '15px' }} />
                }
                {pageDetails.description &&
                    <LongText className={"text"} content={pageDetails.description} renderhtml={true} limit={250} />
                }
            </ContentWithHeading>
            <Divider className={classes.sectionSeparator} />
        </div>
        <div className={classes.consistentPadding}>
            <ContentWithHeading heading={`Donations (${pageDetails.count_donations_millions})`} _className={classes.donationListContainer}>
                {
                    selectedTab == HIGHEST_DONATIONS && <div id="recentDonationsDiv" className={classes.donationsList}>
                        <DonationList donations={highestDonations} totalDonations={highestDonationsCount} listType={HIGHEST_DONATIONS} targetDiv="recentDonationsDiv" />
                    </div>
                }

                {
                    selectedTab == RECENT_DONATIONS && <div id="topDonationsDiv" className={classes.donationsList}>
                        <DonationList donations={recentDonations} totalDonations={recentDonationsCount} listType={RECENT_DONATIONS} targetDiv="topDonationsDiv" />
                    </div>
                }
            </ContentWithHeading>

            <MixPanelTrackedLink
                type="button"
                label="See recent donations"
                context="See recent donations"
                variant="outlined"
                color="neutral"
                onClick={changeTab}
                fullWidth
            >
                {selectedTab == HIGHEST_DONATIONS ? 'See recent donations' : 'See top donations'}
            </MixPanelTrackedLink>
        </div>

        {pageMessages.total || pageComments.count || pageDetails.user_id == user.id || (pageDetails.page_type == TEAM_PAGE && pageDetails.team_members) ? <Divider className={classes.sectionSeparator} /> : null}

        {pageDetails.page_type == TEAM_PAGE && pageDetails.team_members ?
            <>
                <TeamSection />
                <Divider className={classes.sectionSeparator} />
            </> : null}


        {pageDetails && <PageMessages />}

        {pageMessages.total && pageComments.count ? <Divider className={classes.sectionSeparator} /> : null}

        {pageDetails && <PageComments />}

        <InviteTeamMemberModal openModal={openInvitationModal} setOpenModal={setOpenInvitationModal} />
        <WarningModal open={openWarningModal} setOpen={setOpenWarningModal} message={warningMessage} />
        <ShareFundraiserModal openModal={openShareModal} setOpenModal={setOpenShareModal} />
    </React.Fragment>
}